module.exports = __webpack_public_path__ + "img/yishouk.686c0e47.png";